import React, { useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import NavLink from 'react-bootstrap/NavLink';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import { useContentfulMultipleEntry } from '../../hooks/useContentfulMultipleEntry';

function ThreeCards({ section, zIndex }) {
  const items = section?.fields?.items || [];
  const { entries, loading, error } = useContentfulMultipleEntry(items);

  if (loading) return null;
  if (error) return null;
  if (!entries || entries.length === 0) return null;

  let topEdgeTopStyle = {
    paddingTop: '1rem',
    backgroundColor: '#f3f1e6' // To Do. Make these styles classes.
  };

  switch (section.fields.roughEdgeTop) {
    case 'Off White Hero':
      topEdgeTopStyle = {
        marginTop: -80,
        paddingTop: 40,
        backgroundImage: `url("/images/rough-edge-off-white.png")`,
        backgroundRepeat: "no-repeat",
        zIndex: zIndex
      };
      break;
    case 'Lime Green Hero':
      topEdgeTopStyle = {
        marginTop: -80,
        paddingTop: 40,
        backgroundImage: `url("/images/rough-edge-lime-green.png")`,
        backgroundRepeat: "no-repeat",
        zIndex: zIndex
      };
      break;
    case 'Off White':
      topEdgeTopStyle = {
        marginTop: -30,
        paddingTop: 35,
        backgroundImage: `url("/images/rough-edge-off-white.png")`,
        backgroundRepeat: "no-repeat",
        zIndex: zIndex
      };
      break;
    case 'Lime Green':
      topEdgeTopStyle = {
        marginTop: -30,
        paddingTop: 35,
        backgroundImage: `url("/images/rough-edge-lime-green.png")`,
        backgroundRepeat: "no-repeat",
        zIndex: zIndex
      };
      break;
    default:
  }

  return (
    <Container
      id='three-cards'
      fluid
      style={{
        ...topEdgeTopStyle,
        paddingLeft: 0,
        paddingRight: 0,
      }}
    >
      <Row
        className="gx-5"
        style={{
          backgroundColor: '#CCD553',
          paddingTop: '2rem',
          paddingBottom: '1rem',
          paddingLeft: '2rem',
          paddingRight: '2rem',
          marginLeft: 0,
          marginRight: 0,
        }}
      >
        {entries.slice(0, 3).map((item, i) =>
          <BftCard item={item} key={i} />
        )}
      </Row>
    </Container>
  );
}

export default ThreeCards;

function BftCard(props) {
  const { item } = props;

  const cardImage = item.fields.image ?
    item.fields.image.fields.file.url :
    null;

  let heading = <h2>{item.fields.headline}</h2>;
  let image = <Card.Img variant="top" style={{ height: 300, objectFit: 'cover' }} src={cardImage} />;
  if (item.fields.callToAction) {
    if (item.fields.callToActionArticle) {
      heading = <h2><NavLink style={{ padding: 0 }} href={item.fields.callToActionArticle.fields.url}>{item.fields.headline}</NavLink></h2>;
      image = <NavLink style={{ padding: 0 }} href={item.fields.callToActionArticle.fields.url}><Card.Img variant="top" style={{ height: 300, objectFit: 'cover' }} src={cardImage} /></NavLink>;
    } else if (item.fields.callToActionUrl) {
      heading = <h2><NavLink style={{ padding: 0 }} href={item.fields.callToActionUrl}>{item.fields.headline}</NavLink></h2>;
      image = <NavLink style={{ padding: 0 }} href={item.fields.callToActionUrl}><Card.Img variant="top" style={{ height: 300, objectFit: 'cover' }} src={cardImage} /></NavLink>;
    }
  }
  return (
    <Col lg={4} md={12} sm={12} xs={12} className="mb-4">
      <Card className="h-100">
        <Card.Body>
          <Card.Title style={{ height: '3rem', textAlign: 'center' }}>
            {heading}
          </Card.Title>
          <Card.Text style={{ textAlign: 'center' }} className="tagline truncate-overflow">{item.fields.tagline}</Card.Text>
          {image}
        </Card.Body>
      </Card>
    </Col>
  );
}
